const navigationMenu = {
  'USERS': 'Users',
  'ROLES': 'Roles',
  'SECURITY': 'Security',
  'Dealer Request': 'Dealer Request',
  'CONTROLLER_OPTION': 'Controller',
  'HOLIDAY_OPTION': 'Holiday',
  'SCHEDULE_OPTION': 'Schedule',
  'ACCESSLEVEL_OPTION': 'Access Level',
  'GLOBALSETTINGS_OPTION': 'Global Settings',
  'EVENT_OPTION': 'Events',
  'ACCOUNT_INFO': 'Account info',
  'LOCKDOWN_OPTION': 'Lockdown',
  'FLOOR_PLAN_OPTION': 'Floor Plan',
  'HARDWARE': 'Hardware',
  'SETTINGS': 'Settings',
  'Reports': 'Reports',
  'Input': 'Input',
  'Output': 'Output',
  'firmware_manager': 'Firmware Manager',
  'ORGUSERS_REPORT': 'Users report',
  'ORGCARDS_REPORT': 'Credentials report',
  'Events': 'Events report',
  'INTERLOCK_OPTION': 'Interlocks',
  'CDVI_HELP_CONFIGURATION': 'Help Configuration',
  'banner_configuration': 'Banner configuration',
  'STRIPE': 'Stripe',
  'menu': {
    home: 'Home',
    diagnose_controller: 'Diagnose controller',
    new_session: 'New session',
    open_sessions: 'Open sessions',
    current_session: 'Current session',
    dealer: 'Dealer',
    dealer_request: 'Dealer request',
    accounts: 'Accounts',
    help_configuration: 'Help configuration',
    stripe: 'Stripe',
    stripe_sync_issues: 'Stripe sync issues',
    account_info: 'Account info',
    credentials: 'Credentials',
    doors: 'Doors',
    events: 'Events',
    global_settings: 'Global settings',
    hardware: 'Hardware',
    controllers: 'Controllers',
    outputs: 'Outputs',
    firmwares: 'Firmwares',
    notifications: 'Notifications',
    reports: 'Reports',
    users: 'Users',
    settings: 'Settings',
    holidays: 'Holidays',
    schedules: 'Schedules',
    access_levels: 'Access levels',
    lockdown: 'Lockdown',
    floor_plans: 'Floor plans',
    interlocks: 'Interlocks',
    sites: 'Sites',
    site_info: 'Site info',
    firmware_manager: 'Firmware manager',
    testing_tool: 'Testing tool',
    tasks: 'Tasks',
    anti_passback: 'Anti-passback',
  },
  'config': {
    profile: 'Profile',
    dealer_info: 'Dealer Info',
    logout: 'Logout',
    change_password: 'Change Password',
    switch_profile: 'Switch Profile',
    language: 'Language',
  },
  'switch': {
    welcome: 'Welcome <1>{{ name }}</1>,',
    explanation:
      'Several profiles are associated with your user. You can switch between them at any time here:',
    name: 'Name',
    last_login: 'Last Login',
    actions: 'Actions',
    login: 'Login',
    active_profile: 'Active Profile',
    as_dealer: 'As Dealer',
    as_organization: 'As Account',
    as_system: 'As System',
  },
  'version': {
    label: 'Version',
    copied: 'Copied!',
  },
  'section_customer_support': 'Customer Support',
  'section_administration': 'Administration',
  'section_account': 'Account',
  'section_technical_support': 'Technical Support',
  'change_password_instruction_1':
    'To change your password, please log out first.',
  'change_password_instruction_2':
    'Once you\'re on the login screen, wait until the "Forgot your password?" option appears, then click it and follow the instructions to reset your password.',
};

export default navigationMenu;
